import ObjectRender from '@common/screens/RenderScreen/ObjectRender';
import { ElementType, IGroup } from '@common/types/element';
import { isEmpty, isNil, map } from 'lodash';
import React, { FC, useMemo } from 'react';
import { TouchableOpacity, View } from 'react-native';
import createStyles from './style';
import GroupScrollableWrapper from '@common/components/Group/components/Scrollable';
import { getActions } from '@common/utils/handleActions/func/helps';

const CusGroup: FC<IGroup> = (attrs) => {
  const styles = createStyles(attrs);

  const {
    children,
    isInCustomList,
    scroll,
    onPress,
    clipContent,
    clipMainBackground,
  } = attrs;

  const mapElementChild = (child: ElementType) => {
    const groupActionId = attrs?.actions && Object.keys(attrs.actions)[0];
    const allowListAction = isEmpty(child?.actions) && !isEmpty(groupActionId);
    const selectedItem = {
      itemId: attrs.selectedItem?._id,
      tableId: attrs.selectedItem?.tableId,
      itemIndex: attrs.selectedItem?.itemIndex,
    };

    const mappedObject = {
      ...child,
      ...(isNil(child.actions) || isEmpty(child.actions)
        ? { actions: attrs.actions }
        : {
            actions: {
              ...child?.actions,
              ...attrs?.actions,
            },
          }),
      currentScroll: {
        active: true,
        arrange: scroll?.arrange,
      },
      selectedItem,
      record: attrs.record,
      groupActionId,
      currentListIds: { ...(attrs.currentListIds || {}) },
      currentRecordIds: { ...(attrs.currentRecordIds || {}) },
      currentListId: attrs?.currentListId || attrs.id,
      ...(isInCustomList && {
        initId: `${child.id}`,
      }),
      allowListAction,
      screenUuid: attrs?.screenUuid,
    };

    return mappedObject;
  };

  const arrCom = useMemo(
    () =>
      map(children, (child) => {
        const isFixedElement =
          (child.fixPosition === 'top' || child.fixPosition === 'bottom') &&
          child.type === 'section';
        if (
          (isFixedElement && clipContent) ||
          (clipMainBackground && clipMainBackground == child.id)
        ) {
          return null;
        }
        return mapElementChild(child);
      }).filter(Boolean) as ElementType[],
    [children, attrs.record, attrs?.actions, attrs.selectedItem]
  );

  const fixedElements = useMemo(
    () =>
      map(children, (child) => {
        const isFixedElement =
          (child.fixPosition === 'top' || child.fixPosition === 'bottom') &&
          child.type === 'section';
        if (clipMainBackground) {
          const isMainBG = clipMainBackground == child.id;
          if (isMainBG) {
            child.fixPosition = 'top';
            child.height = attrs.height;
            child.width = attrs.width;
            child.x = attrs.x;
            child.y = attrs.y;
            return mapElementChild(child);
          } else return null;
        } else {
          if (!isFixedElement) {
            return null;
          }
          return mapElementChild(child);
        }
      }).filter(Boolean) as ElementType[],
    [children, attrs.record, attrs?.actions, attrs.selectedItem]
  );

  if (children.length == 0) return <React.Fragment />;

  const layout = {
    offsetTop: attrs?.y,
    offsetLeft: attrs?.x,
    parentWidth: attrs?.width,
  };
  const emptyAction = isEmpty(attrs.actions);
  if (clipContent) {
    return (
      <>
        <GroupScrollableWrapper
          attrs={attrs}
          scroll={attrs.scroll}
          clipContent={clipContent}
          fixedElements={fixedElements}
        >
          {emptyAction ? (
            <>
              <View style={{ ...styles.container }}>
                <ObjectRender
                  keyItem={attrs?.selectedItem?.itemIndex}
                  arrComp={arrCom}
                  isScreen={false}
                  layout={{
                    offsetLeft: attrs.x,
                    offsetTop: attrs.y,
                    parentWidth: attrs?.width,
                  }}
                />
              </View>
            </>
          ) : (
            <View style={styles.container}>
              <TouchableOpacity
                onPress={() => {
                  onPress(getActions(attrs.actions), {});
                }}
                style={{
                  minHeight: attrs.height,
                  width: attrs.width,
                }}
                activeOpacity={1}
              >
                <ObjectRender
                  keyItem={attrs?.selectedItem?.itemIndex}
                  arrComp={arrCom}
                  isScreen={false}
                  layout={layout}
                />
              </TouchableOpacity>
            </View>
          )}
        </GroupScrollableWrapper>
      </>
    );
  } else {
    return (
      <>
        <GroupScrollableWrapper attrs={attrs} scroll={attrs.scroll}>
          {emptyAction ? (
            <View style={styles.container}>
              <ObjectRender
                keyItem={attrs?.selectedItem?.itemIndex}
                arrComp={arrCom}
                isScreen={false}
                layout={layout}
              />
            </View>
          ) : (
            <View style={styles.container}>
              <TouchableOpacity
                onPress={() => {
                  onPress(getActions(attrs.actions), {});
                }}
                style={{
                  minHeight: attrs.height,
                  width: attrs.width,
                }}
                activeOpacity={1}
              >
                <ObjectRender
                  keyItem={attrs?.selectedItem?.itemIndex}
                  arrComp={arrCom}
                  isScreen={false}
                  layout={layout}
                />
              </TouchableOpacity>
            </View>
          )}
        </GroupScrollableWrapper>
      </>
    );
  }
};

export default CusGroup;
